import { createContext, useState, useEffect } from 'react';
import { getLocale } from '@izettle/react';
import { Translator } from '../translator.js';
import { jsx } from 'react/jsx-runtime';

const replacementIndexRegex = /{(\d+)}/g;
const replacementRegex = /({\d+})/;
const replacePlaceholders = function (text) {
  let replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (replacements.length < 1) {
    return text;
  }

  // Simple regex replace if it's all strings
  if (replacements.every(r => typeof r === "string" || typeof r === "number" || r == null)) {
    return text
    // Replace with replacement or nothing if no replacement is found
    .replace(replacementIndexRegex, (_, replacementIndex) => {
      return replacements[Number(replacementIndex[0])] ?? "";
    });
  }

  // Otherwise split into array and replace with strings and jsx elements
  return text.split(replacementRegex).map(str => {
    const match = replacementRegex.exec(str);
    if (!match) {
      return str;
    }
    const replacementIndex = /\d+/.exec(match[0])[0];
    return replacements[Number(replacementIndex)];
  });
};
const getLocaleOptions = function () {
  for (let i = 0; i < arguments.length; i++) {
    const input = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (input == null) {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (typeof input === "string") {
      return Translator.optionsFromIsoLocale(input);
    }
    return input;
  }
  throw new Error("Could not get locale options!");
};
const TranslatorContext = /*#__PURE__*/createContext(null);
const TranslationsProvider = _ref => {
  let {
    locale: localeOverride,
    defaultLocale,
    children,
    onLoadTranslationsError,
    ...translatorProps
  } = _ref;
  const [data, setData] = useState(null);
  const resolvedLocale = getLocaleOptions(localeOverride, getLocale(window.navigator.languages), defaultLocale);
  useEffect(() => {
    const translator = new Translator({
      ...translatorProps,
      locale: resolvedLocale
    });
    void translator.loadTranslations().then(() => setData({
      translator,
      text: (key, replacements) => replacePlaceholders(translator.translate(key), replacements)
    })).catch(onLoadTranslationsError);
  }, [resolvedLocale.language, resolvedLocale.country, resolvedLocale.currency]);
  return data ? /*#__PURE__*/jsx(TranslatorContext.Provider, {
    value: data,
    children: children
  }) : null;
};

export { TranslationsProvider, TranslatorContext, replacePlaceholders };
//# sourceMappingURL=translations.js.map
